import React from "react"
import { Button } from "../button/button"
import { Cross } from "./cross"
import { ITooltipProps } from "./model"

import "./style.scss"

export function Tooltip({ closeTooltip }: ITooltipProps) {
    const tooltipContent = {
        heading: "See it in action",
        body: `Toggle to 'Edit' to add your email signature details & branding. Then toggle back to 'Preview' to see your everyday email become a powerful marketing tool.`,
    }

    return (
        <React.Fragment>
            <div className="tooltip mbl-only">
                <div className="tooltip-position">
                    <div className="tooltip-close" onClick={closeTooltip}>
                        <Cross />
                    </div>
                    <div className="tooltip-content">
                        <h4>{tooltipContent.heading}</h4>
                        <p>{tooltipContent.body}</p>
                        <Button className="tooltip-btn" variant="secondary" onClick={closeTooltip}>
                            Got it
                        </Button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Tooltip
